import { pick } from "lodash";
import { ADMIN_MODAL_FORMS, ADMIN_TABLES } from "../../../constants/actions";
import { events } from "../../../services/api.admin";
import { deleteTableData, fetchTableData, refresh } from "../tables";
import { MODELS } from "../../../constants/admin/settings";
import { selectedSelector } from "../../../selectors/admin/tables";
import { apiMultipleCalls } from "../../helpers";

export function fetchEventReminders(eventId) {
    return fetchTableData(() => events.getReminders(eventId), 'reminders', {});
}

export function createEventReminder(data, eventId) {
    return (dispatch) => { 
        dispatch({ type: ADMIN_MODAL_FORMS.SUBMIT });
        return  events.createReminder(eventId, data).then(
            () => {
                dispatch({ type: ADMIN_MODAL_FORMS.SUCCESS });
                dispatch(refresh());
            }
        )
    }
}

export function updateEventReminder(data, eventId) {
    return (dispatch) => { 
        dispatch({ type: ADMIN_MODAL_FORMS.SUBMIT });
        return  events.updateReminder(eventId, data.id ,_permitBody(data)).then(
            () => {
                dispatch({ type: ADMIN_MODAL_FORMS.SUCCESS });
                dispatch(refresh());
            }
        )
    }
}

export function deleteEventReminders(eventId) {
    return (dispatch, getState) => {
        const tableIndex = 0;
        dispatch({ type: ADMIN_TABLES.DISABLE, index: tableIndex });
        const selected = selectedSelector(getState(), {});
        return apiMultipleCalls(
            dispatch,
            selected.map((reminder) => 
                () => events.removeReminder(eventId, reminder)
            ),
            () => {
                dispatch({ type: ADMIN_TABLES.DELETE, index: tableIndex, removed: selected });
                dispatch(refresh());
            },
            0,
            {},
            false
        );
    };
}

const _permitBody = (data) =>
    pick(
        data,
        ['name', 'dueDate', 'contractType', 'comments']
    );


// WEBPACK FOOTER //
// ./src/actions/admin/models/event.reminders.js